import { IModel, IAttribute } from './../base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { IPrivateEndpointCompatible, Credential, cosmosSqlAuthMethod } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.cosmosSql.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.CosmosDb_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.CosmosDb_DisplayText)
    ]
})
export class AzureCosmosDBLinkedService extends LinkedService implements IPrivateEndpointCompatible {

    public static readonly MODEL: IModel;
    public static readonly ACCOUNT_ENDPOINT: IAttribute;
    public static readonly ACCOUNT_KEY: IAttribute;
    public static readonly DATABASE_NAME: IAttribute;
    public static readonly TENANT: IAttribute;
    public static readonly SERVICE_PRINCIPAL_ID: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_AzureCosmosAccountName,
        association: 'ACCOUNT_ENDPOINT',
        templatable: true
    })
    public accountEndpoint?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AzureCosmosAccountKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'ACCOUNT_KEY',
        templatable: true,
        accepts: ['String']
    })
    public accessKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName,
        association: 'DATABASE_NAME',
        templatable: true
    })
    public databaseName?: string;

    public enableAKVForConnectionString?: boolean = false;
    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKVForConnectionString?: AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant,
        association: 'TENANT',
        templatable: true
    })
    public tenant?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID,
        association: 'SERVICE_PRINCIPAL_ID',
        templatable: true
    })
    public servicePrincipalId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalCredentialType
    })
    public servicePrincipalCredentialType?: 'ServicePrincipalKey' | 'ServicePrincipalCert';

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalCert,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public servicePrincipalCert?: AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.AuthenticationType_UseCredentials,
        reference: true
    })
    public credential?: Credential;

    public authenticationMethod?: string = cosmosSqlAuthMethod.connectionString;

    private _accountResourceID: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public getPEResourceIDAndName(): { id: string, name: string } {
        let resourceName = '';
        if (this.accountEndpoint && this.accountEndpoint.toLowerCase().startsWith('https://')) {
            resourceName = this.accountEndpoint.substr(8).split('.')[0];
        }
        if (!resourceName || this._accountResourceID && !this._accountResourceID.endsWith('/' + resourceName)) {
            this._accountResourceID = undefined;
        }
        return {
            id: this._accountResourceID,
            name: resourceName
        };
    }

    public setPEResourceID(id: string): void {
        this._accountResourceID = id;
    }

    public reset(): void {
        this.credential = undefined;
        this.servicePrincipalCert = undefined;
        this.servicePrincipalKey = undefined;
        this.referedAKVForConnectionString = undefined;
    }
}
